/* MOOUI: comportamento isolado do quick shop mobile. */
(function () {
  'use strict';

  let quickshopReadyAt = 0;

  function applyExactVariant(input) {
    if (!input || input.disabled) return false;

    const form = input.closest('form');
    const variantId = input.getAttribute('data-variant-id');
    const variantSelect = form && form.querySelector('select[name="id"]');
    if (!form || !variantId || !variantSelect) return false;

    const matchingOption = Array.from(variantSelect.options).find(function (option) {
      return option.value === variantId;
    });
    if (!matchingOption || matchingOption.disabled) return false;

    variantSelect.value = variantId;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

    const addButton = form.querySelector('[data-btn-addToCart]');
    if (addButton) {
      addButton.disabled = false;
      addButton.removeAttribute('aria-disabled');
    }
    return true;
  }

  function submitQuickshop(input) {
    if (!input || window.innerWidth > 767) return;
    if (input.dataset.novaUserIntent !== 'true') return;
    delete input.dataset.novaUserIntent;

    const form = input.closest('form[data-nova-mobile-instant-add]');
    if (!form || form.dataset.novaSubmitting === 'true') return;

    const addButton = form.querySelector('[data-btn-addToCart]');
    if (!addButton || addButton.disabled) return;

    form.querySelectorAll('input[name="quantity"]').forEach(function (quantity) {
      quantity.value = '1';
    });

    form.dataset.novaSubmitting = 'true';
    window.setTimeout(function () {
      addButton.click();
      window.setTimeout(function () {
        delete form.dataset.novaSubmitting;
      }, 1200);
    }, 60);
  }

  function getSizeInput(target) {
    const directInput = target.closest(
      '[data-nova-bundle-size], [data-nova-variant-choice], [data-nova-size-option]'
    );
    if (directInput) return directInput;

    const label = target.closest('.nova-bundle-size-button, label.single-label');
    if (!label) return null;

    if (label.matches('.nova-bundle-size-button')) {
      return label.querySelector('[data-nova-bundle-size], [data-nova-variant-choice]');
    }

    const inputId = label.getAttribute('for');
    return inputId ? document.getElementById(inputId) : null;
  }

  function markUserIntent(event) {
    if (Date.now() < quickshopReadyAt) return;
    const input = getSizeInput(event.target);
    if (input) input.dataset.novaUserIntent = 'true';
  }

  function clearAutomaticSelection() {
    document
      .querySelectorAll(
        '#halo-card-mobile-popup [data-nova-bundle-size], #halo-card-mobile-popup [data-nova-variant-choice], #halo-card-mobile-popup [data-nova-size-option]'
      )
      .forEach(function (input) {
        if (input.dataset.novaUserIntent !== 'true') input.checked = false;
      });
  }

  document.addEventListener('pointerdown', markUserIntent, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') markUserIntent(event);
  }, true);

  document.addEventListener('change', function (event) {
    const bundleSize = event.target.closest('[data-nova-bundle-size], [data-nova-variant-choice]');
    if (bundleSize) {
      if (applyExactVariant(bundleSize) && event.isTrusted) submitQuickshop(bundleSize);
      return;
    }

    const standardSize = event.target.closest('[data-nova-size-option]');
    if (standardSize && event.isTrusted) submitQuickshop(standardSize);
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.nova-card-buy-mobile');
    if (!trigger) return;

    quickshopReadyAt = Date.now() + 400;
    document.body.classList.add('nova-quickshop-opening');

    window.setTimeout(function () {
      document
        .querySelectorAll('.nova-card-buy-mobile.is-loading')
        .forEach(function (button) {
          button.classList.remove('is-loading');
        });

      clearAutomaticSelection();
      window.setTimeout(clearAutomaticSelection, 120);
      window.setTimeout(function () {
        clearAutomaticSelection();
        document.body.classList.remove('nova-quickshop-opening');
      }, 320);
    }, 80);
  }, true);

  function resetQuickshopAfterDesktopBreakpoint(event) {
    if (!event.matches) return;

    document.body.classList.remove(
      'quick_shop_popup_mobile',
      'nova-quickshop-opening',
      'quickshop-list-view-show'
    );

    document.querySelectorAll('.quickshop-popup-show').forEach(function (item) {
      item.classList.remove('quickshop-popup-show');
    });

    const popup = document.getElementById('halo-card-mobile-popup');
    if (popup) {
      popup.classList.remove('show');
      const clonedContent = popup.querySelector('.halo-card-mobile-content');
      if (clonedContent) clonedContent.replaceChildren();
    }
  }

  const desktopBreakpoint = window.matchMedia('(min-width: 768px)');
  if (desktopBreakpoint.addEventListener) {
    desktopBreakpoint.addEventListener('change', resetQuickshopAfterDesktopBreakpoint);
  } else {
    desktopBreakpoint.addListener(resetQuickshopAfterDesktopBreakpoint);
  }
})();
